import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import CrcDialog from '../../../modules/checkListGenerator/crcChecklist/crcChecklistAddRelevancePopUp';
import { createIncomeTaxRequest, createGenInfoRequestSave, panelIndexUpdate } from '../../../modules/checkListGenerator/store/actions/index';
import buttonDisable from '../../disableField/buttonDisable';
import { userType } from '../../../config/usertypeValue';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    withoutLabel: {
        marginTop: theme.spacing(3),
    },
    textField: {
        width: '25ch',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    button: {
        margin: '10px 0px 5px !important',
        width: '155px',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
    },
    checked: {},
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#137cbd',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#106ba3',
        },
    },
    inlineDisplay: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            display: 'inline-block',
            padding: '0px 10px 0px 0px',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    expenditure: {
        listStyle: 'none',
        padding: '0',
        '& li': {
            padding: '10px 0',
            color: '#7779ba',
        },
        '& label': {
            marginLeft: '0',
        },
    },
    relevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#3ccbcb',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    irrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: '#db466b',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },

    partrelevanceIndicator: {
        color: '#f9f9f9',
        backgroundColor: ' #FFC300',
        paddingTop: '5px',
        paddingRight: '40px',
        paddingBottom: '5px',
        paddingLeft: '40px',
        fontFamily: 'Rubik',
    },
}));
function StyledRadio(props) {
    const classes = useStyles();

    return (
        <Radio
            className={classes.root}
            disableRipple
            color="default"
            checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
            icon={<span className={classes.icon} />}
            {...props}
        />
    );
}

export default function CrcIncomeTax(props) {
    const dispatch = useDispatch({});
    const classes = useStyles();
    const [itecOpen, setItecOpen] = React.useState(false);
    const [provide, setprovide] = useState('none');
    const [available, setAvailable] = useState('Available');
    const [lost, setLost] = useState('none');
    const [relevanceCat, setRelevanceCat] = React.useState('');
    const [relevenceDispay, setRelevenceDispay] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [remarks, setRemarks] = React.useState('');
    const [apiResponse, setApiResponse] = React.useState('');
    //console.log('apiResponse...166', apiResponse);
    const [apiResponseBank, setApiResponseBank] = React.useState('');
    const [apithirdscreenvalues, setApithirdscreenvalues] = React.useState('');
    const [apigeneralinfo, setApigeneralinfo] = React.useState('');
    const [apitravelOutside, setApitravelOutside] = React.useState('');
    const [apidirectorCompany, setApidirectorCompany] = React.useState('');
    const [apiassetHome, setApiassetHome] = React.useState('');
    const [apiassetNature, setApiassetNature] = React.useState('');
    const [apiclient1, setApiclient1] = React.useState('');
    const [apiclient2, setApiclient2] = React.useState('');
    const [apiclient3, setApiclient3] = React.useState('');
    const [apiclient4, setApiclient4] = React.useState('');
    const [apiclient5, setApiclient5] = React.useState('');
    const [apiclient6, setApiclient6] = React.useState('');
    const [apiclient7, setApiclient7] = React.useState('');
    const [apiclient8, setApiclient8] = React.useState('');
    const [apiclient9, setApiclient9] = React.useState('');
    const [apiclient10, setApiclient10] = React.useState('');
    const [apilabelAdata, setApilabelAdata] = React.useState('');
    const [apilabelBdata, setApilabelBdata] = React.useState('');
    const [apilabelCdata, setApilabelCdata] = React.useState('');
    const [apilabelDdata, setApilabelDdata] = React.useState('');
    const [apilabelEdata, setApilabelEdata] = React.useState('');
    const [apiyesorNoType, setApiyesorNoType] = React.useState('');
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);

    const [apiAddAdditionalQue, setApiAddAdditionalQue] = React.useState('');
    const [formValues, setformValues] = React.useState({
        incomeUserId: '',
        incomePassword: '',
    });
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const [values, setValues] = React.useState({
        showPassword: false,
    });

    // const createbankDetails = useSelector((state) => state.geninforeducer.createbankdetails);
    // const tempValuesBank = createbankDetails && createbankDetails.params;
    // const createGenInfo = useSelector((state) => state.geninforeducer.creategeninfo);
    // const tempValues = createGenInfo && createGenInfo.params;

    const createincometax = useSelector((state) => state.geninforeducer.createincometax);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const stageId = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const statusIDResult = props.serviceIdValue;
    const [showLoader, setShowLoader] = useState(false);


    let tempincometax = {};
    if (createincometax.serviceIdValue === statusIDResult) {
        tempincometax = createincometax && createincometax.params;
    }

    const handleRoleChange = (event) => {
        setAvailable(event.target.value);

        switch (event.target.value) {
            case 'available':
                setAvailable('block');
                setprovide('none');
                setLost('none');
                //console.log('expenditure');

                return true;
            case 'provide':
                setprovide('block');
                setAvailable('none');
                setLost('none');
                //console.log('records');
                return true;
            case 'lost':
                setLost('block');
                setAvailable('none');
                setprovide('none');
                //console.log('banksAcc');
                return true;
            default:
                return true;
        }
    };

    const handleRelevence = (name, categoryValue, remarksValue) => {
        setCategory(categoryValue);
        setRemarks(remarksValue);
        setRelevanceCat(name);
        setTimeout(() => {
            setItecOpen(true);
        }, 1000);
    };

    const handleItecClose = () => {
        setTimeout(() => {
            setItecOpen(false);
        }, 1000);
    };

    useEffect(() => {
        setApiResponse(props.apiResponse);
        setApiResponseBank(props.bankDetails);
        setApithirdscreenvalues(props.thirdscreenvalues);
        setApigeneralinfo(props.generalinfo);
        setApitravelOutside(props.travelOutside);
        setApidirectorCompany(props.directorCompany);
        setApiassetHome(props.assetHome);
        setApiassetNature(props.assetNature);
        setApiclient1(props.client1);
        setApiclient2(props.client2);
        setApiclient3(props.client3);
        setApiclient4(props.client4);
        setApiclient5(props.client5);
        setApiclient6(props.client6);
        setApiclient7(props.client7);
        setApiclient8(props.client8);
        setApiclient9(props.client9);
        setApiclient10(props.client10);
        setApilabelAdata(props.labelAdata);
        setApilabelBdata(props.labelBdata);
        setApilabelCdata(props.labelCdata);
        setApilabelDdata(props.labelDdata);
        setApilabelEdata(props.labelEdata);
        setApiyesorNoType(props.yesorNoType);
        setApiAddAdditionalQue(props.addAdditionalQue);

        //console.log('4th screen res', props.apiResponse);
        if (props.apiResponse) {
            const iniVal = {
                incomeUserId: apiResponse && apiResponse.fields[1].response,
                userIdRelevance: apiResponse && apiResponse.fields[1].relevanceResponseCRC,
                userIdRelevanceRemarks: apiResponse && apiResponse.fields[1].relevanceRemarksCRC,

                incomePassword: apiResponse && apiResponse.fields[2].response,
                passwordRelevance: apiResponse && apiResponse.fields[2].relevanceResponseCRC,
                passwordRelevanceRemarks: apiResponse && apiResponse.fields[2].relevanceRemarksCRC,
            };
            setformValues(iniVal);
        }
    }, [props]);

    const updateCRCRelevance = (category, remarks) => {
        // setShowLoader(true);
        setTimeout(() => {
            setItecOpen(false);
        }, 2000);
        const data = {
            incomeUserId: apiResponse && apiResponse.fields[1].response,
            userIdRelevance: tempincometax && tempincometax.userIdRelevance,
            userIdRelevanceRemarks: tempincometax && tempincometax.userIdRelevanceRemarks,

            incomePassword: apiResponse && apiResponse.fields[2].response,
            passwordRelevance: tempincometax && tempincometax.passwordRelevance,
            passwordRelevanceRemarks: tempincometax && tempincometax.passwordRelevanceRemarks,

            ...apigeneralinfo,
            ...apithirdscreenvalues,
            bankDetails: apiResponseBank,
            travelOutside: apitravelOutside,
            directorCompany: apidirectorCompany,
            assetHome: apiassetHome,
            assetNature: apiassetNature,
            client1: apiclient1,
            client2: apiclient2,
            client3: apiclient3,
            client4: apiclient4,
            client5: apiclient5,
            client6: apiclient6,
            client7: apiclient7,
            client8: apiclient8,
            client9: apiclient9,
            client10: apiclient10,
            labelAdata: apilabelAdata,
            labelBdata: apilabelBdata,
            labelCdata: apilabelCdata,
            labelDdata: apilabelDdata,
            labelEdata: apilabelEdata,

            incomeTaxType: apiyesorNoType && apiyesorNoType.incomeTaxType,
            traveloutsideType: apiyesorNoType && apiyesorNoType.traveloutsideType,
            directorType: apiyesorNoType && apiyesorNoType.directorType,
            assetradio: apiyesorNoType && apiyesorNoType.assetradio,
            totalincomeradio: apiyesorNoType && apiyesorNoType.totalincomeradio,
            additionalQue: apiAddAdditionalQue,
        };

        if (relevanceCat === 'incomeUserId') {
            data.userIdRelevance = category;
            data.userIdRelevanceRemarks = remarks;
        }
        if (relevanceCat === 'incomePassword') {
            data.passwordRelevance = category;
            data.passwordRelevanceRemarks = remarks;
        }

        // //console.log('CRCIncomeTAX =>>>>>>> data', data);
        props.updateApiData(data);
        setRelevenceDispay(data);
        dispatch(createIncomeTaxRequest({ params: data, serviceIdValue: statusIDResult }));
        dispatch(panelIndexUpdate({ panelID: 'panel4' }));
        dispatch(createGenInfoRequestSave({ params: data, bearerToken, serviceIdValue: statusIDResult, usertype, imcNameSelected }));
        props.onChange(data);
        props.rerenderApi(!props.rerender);
        // setTimeout(() => {
        //     setShowLoader(false);
        // }, 10000);
    };

    return (
        <>
            {showLoader ? (<LoaderPopUp showLoader={showLoader} />) : null}

            <Grid container spacing={3} className="main-container">
                <Grid item xs={12} sm={12}>
                    <FormControl component="fieldset">
                        <RadioGroup
                            value={apiResponse && apiResponse.fields[0].response}
                            aria-label="business"
                            onChange={handleRoleChange}
                            className="radio-option"
                        >
                            <ul className={classes.expenditure}>
                                <li>
                                    <FormControlLabel
                                        value="available"
                                        control={<StyledRadio />}
                                        label="Should be available with you"
                                        disabled
                                    />
                                </li>
                                <li>
                                    <FormControlLabel
                                        disabled
                                        value="provide"
                                        control={<StyledRadio />}
                                        label="Would like to provide the same now"
                                    />
                                </li>
                                <li>
                                    <FormControlLabel value="lost" control={<StyledRadio />} label="Lost / Not created " disabled />
                                </li>
                            </ul>
                        </RadioGroup>
                    </FormControl>

                    {apiResponse && apiResponse.fields[0].response === 'provide' ? (
                        <Grid container spacing={4}>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className={classes.margin}>
                                    <InputLabel htmlFor="user-id">User ID</InputLabel>
                                    <Input
                                        disabled
                                        className={classes.bottomLine}
                                        value={formValues.incomeUserId}
                                    />
                                    <div>
                                        <Typography className={classes.bottomLine}>
                                            {((apiResponse && apiResponse.fields[1].relevanceResponseCRC) ||
                                                relevenceDispay.userIdRelevance) === 'Relevant' ? (
                                                    <div className={classes.relevanceIndicator}>
                                                        {
                                                            // ((apiResponse && apiResponse.fields[1].relevanceRemarksCRC) ||
                                                            //     relevenceDispay.userIdRelevanceRemarks)
                                                            ((apiResponse && apiResponse.fields[1].relevanceRemarksCRC))
                                                        }
                                                    </div>
                                                ) : ((apiResponse && apiResponse.fields[1].relevanceResponseCRC) ||
                                                    relevenceDispay.userIdRelevance) === 'Irrelavant' ? (
                                                        <div className={classes.irrelevanceIndicator}>
                                                            {
                                                                // ((apiResponse && apiResponse.fields[1].relevanceRemarksCRC) ||
                                                                //     relevenceDispay.userIdRelevanceRemarks)
                                                                ((apiResponse && apiResponse.fields[1].relevanceRemarksCRC))
                                                            }
                                                        </div>
                                                    ) : ((apiResponse && apiResponse.fields[1].relevanceResponseCRC) ||
                                                        relevenceDispay.userIdRelevance) === 'Paritially Relevant' ? (
                                                            <div className={classes.partrelevanceIndicator}>
                                                                {
                                                                    // ((apiResponse && apiResponse.fields[1].relevanceRemarksCRC) ||
                                                                    //     relevenceDispay.userIdRelevanceRemarks)

                                                                    ((apiResponse && apiResponse.fields[1].relevanceRemarksCRC))
                                                                }
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                        </Typography>
                                    </div>

                                    {stageId === 10 && usertype === 'EM' ? (
                                        ''
                                    ) : stageId === 8 && apiResponse && apiResponse.fields[1].relevanceResponseCRC === 'Relevant' ? (
                                        ''
                                    ) : (
                                                <Button
                                                    disabled={usertype === 'EM' ? 'disabled' : ''}
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                    className={classes.button}
                                                    startIcon={<InsertCommentIcon />}
                                                    onClick={() =>
                                                        handleRelevence(
                                                            'incomeUserId',
                                                            // relevenceDispay.userIdRelevance,
                                                            // relevenceDispay.userIdRelevanceRemarks
                                                            relevenceDispay.userIdRelevance ||
                                                            (apiResponse && apiResponse.fields[1].relevanceResponseCRC),
                                                            (apiResponse && apiResponse.fields[1].relevanceRemarksCRC) ||
                                                            relevenceDispay.userIdRelevanceRemarks
                                                        )
                                                    }
                                                    disabled={buttonDisable(stageId, userType.value)}
                                                >
                                                    Add Relevance
                                        </Button>
                                            )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth className={classes.margin}>
                                    <InputLabel htmlFor="password">Password</InputLabel>
                                    <Input
                                        disabled
                                        className={classes.bottomLine}
                                        type={values.showPassword ? 'text' : 'password'}
                                        // id="password"
                                        value={formValues.incomePassword}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <IconButton
                                                    aria-label="toggle password visibility"
                                                    onClick={() => setValues({ showPassword: !values.showPassword })}
                                                >
                                                    {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                                </IconButton>
                                            </InputAdornment>
                                        }
                                    // onChange={handleChange('amount')}
                                    />
                                    <div>
                                        <Typography className={classes.bottomLine}>
                                            {((apiResponse && apiResponse.fields[2].relevanceResponseCRC) ||
                                                relevenceDispay.passwordRelevance
                                            ) === 'Relevant' ? (
                                                    <div className={classes.relevanceIndicator}>
                                                        {
                                                            // ((apiResponse && apiResponse.fields[2].relevanceRemarksCRC) ||
                                                            //     relevenceDispay.passwordRelevanceRemarks)
                                                            ((apiResponse && apiResponse.fields[2].relevanceRemarksCRC))
                                                        }
                                                    </div>
                                                ) : ((apiResponse && apiResponse.fields[2].relevanceResponseCRC) ||
                                                    relevenceDispay.passwordRelevance) === 'Irrelavant' ? (
                                                        <div className={classes.irrelevanceIndicator}>
                                                            {
                                                                // ((apiResponse && apiResponse.fields[2].relevanceRemarksCRC) ||
                                                                //     relevenceDispay.passwordRelevanceRemarks)
                                                                ((apiResponse && apiResponse.fields[2].relevanceRemarksCRC))
                                                            }
                                                        </div>
                                                    ) : ((apiResponse && apiResponse.fields[2].relevanceResponseCRC) ||
                                                        relevenceDispay.passwordRelevance) === 'Paritially Relevant' ? (
                                                            <div className={classes.partrelevanceIndicator}>
                                                                {
                                                                    // ((apiResponse && apiResponse.fields[2].relevanceRemarksCRC) ||
                                                                    //     relevenceDispay.passwordRelevanceRemarks)
                                                                    ((apiResponse && apiResponse.fields[2].relevanceRemarksCRC))
                                                                }
                                                            </div>
                                                        ) : (
                                                            ''
                                                        )}
                                        </Typography>
                                    </div>
                                    {stageId === 10 && usertype === 'EM' ? (
                                        ''
                                    ) : stageId === 8 && apiResponse && apiResponse.fields[2].relevanceResponseCRC === 'Relevant' ? (
                                        ''
                                    ) : (
                                                // {stageId === 10 && usertype === 'EM' ? ('') : (
                                                <Button
                                                    // disabled={usertype === 'EM' ? 'disabled' : ''}
                                                    variant="outlined"
                                                    color="primary"
                                                    size="small"
                                                    className={classes.button}
                                                    startIcon={<InsertCommentIcon />}
                                                    onClick={() =>
                                                        handleRelevence(
                                                            'incomePassword',
                                                            // relevenceDispay.passwordRelevance,
                                                            // relevenceDispay.passwordRelevanceRemarks
                                                            relevenceDispay.passwordRelevance ||
                                                            (apiResponse && apiResponse.fields[2].relevanceResponseCRC),
                                                            (apiResponse && apiResponse.fields[2].relevanceRemarksCRC) ||
                                                            relevenceDispay.passwordRelevanceRemarks
                                                        )
                                                    }
                                                    disabled={buttonDisable(stageId, userType.value)}
                                                >
                                                    Add Relevance
                                        </Button>
                                            )}
                                </FormControl>
                            </Grid>
                        </Grid>
                    ) : (
                            ''
                        )}
                    {/* </div> */}
                </Grid>
            </Grid>
            {itecOpen && (
                <CrcDialog
                    itecOpen={itecOpen}
                    crcCategory={category}
                    crcRemarks={remarks}
                    updateCRCRelevance={updateCRCRelevance}
                    handleItecClose={handleItecClose}
                />
            )}
            {/* {itecOpen && <CrcDialog itecOpen={itecOpen} updateCRCRelevance={updateCRCRelevance} handleItecClose={handleItecClose} crcCategory={category} crcRemarks={remarks}/>}  
            {itecOpen && <CrcDialog itecOpen={itecOpen} updateCRCRelevance={updateCRCRelevance} handleItecClose={handleItecClose} />} */}
        </>
    );
}
